module.exports = "<p ng-repeat=\"error in errors\"> {{error}} </p> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/notifications/api-errors.html
// module id = 461
// module chunks = 0